module.exports = __webpack_public_path__ + "img/coin-002.b9b59b4f.svg";